module.exports = __webpack_public_path__ + "img/Vegetable-Lasagna-Horizontal-1.8d4babd5.jpg";